import { getFilters } from "./duckFilter";

const LOAD_LAYOUTSFILTER = "LOAD_LAYOUTSFILTER";
const LOAD_LAYOUTSFILTER_SUCCESS = "LOAD_LAYOUTSFILTER_SUCCESS";
const LOAD_LAYOUTSFILTER_FAIL = "LOAD_LAYOUTSFILTER_FAIL";
const CLEAN_LAYOUTSFILTER = "CLEAN_LAYOUTSFILTER";

const LOAD_LAYOUTFILTER = "LOAD_LAYOUTFILTER";
const LOAD_LAYOUTFILTER_SUCCESS = "LOAD_LAYOUTFILTER_SUCCESS";
const LOAD_LAYOUTFILTER_FAIL = "LOAD_LAYOUTFILTER_FAIL";

const LAYOUTFILTER_POST = "LAYOUTFILTER_POST";
const LAYOUTFILTER_PUT = "LAYOUTFILTER_PUT";
const LAYOUTFILTER_DELETE = "LAYOUTFILTER_DELETE";

export default function layout(
  state = {
    data: [],
    isLoading: true,
    hasErrored: false,
    message: "",
    layoutFiltersSelected: [],
  },
  action,
) {
  switch (action.type) {
    case LOAD_LAYOUTSFILTER: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case LOAD_LAYOUTSFILTER_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case LOAD_LAYOUTSFILTER_SUCCESS: {
      return Object.assign({}, state, {
        data: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }

    case LOAD_LAYOUTFILTER: {
      return Object.assign({}, state, {
        isLoading: true,
      });
    }

    case LOAD_LAYOUTFILTER_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        hasErrored: true,
      });
    }
    case LOAD_LAYOUTFILTER_SUCCESS: {
      return Object.assign({}, state, {
        layoutFiltersSelected: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }

    case CLEAN_LAYOUTSFILTER: {
      return Object.assign({}, state, {
        data: [],
      });
    }
    default:
      return state;
  }
}

export function getLayoutFilters() {
  return {
    type: LOAD_LAYOUTSFILTER,
    payload: {
      request: {
        url: "LayoutFilter",
      },
    },
  };
}
/**
 * Get Relationships by LayoutId
 * @param {number} id LayoutId
 */
export function getByLayoutId(id) {
  return {
    type: LOAD_LAYOUTFILTER,
    payload: {
      request: {
        url: "LayoutFilter/GroupedByTabs/Layout/" + id,
      },
    },
  };
}

/**
 * Get Relationships by FilterId
 * @param {number} id FilterId
 */
export function getByFilterId(id) {
  return {
    type: LOAD_LAYOUTFILTER,
    payload: {
      request: {
        url: "LayoutFilter/Filter/" + id,
      },
    },
  };
}

export function addLayoutFilter(layoutFilter) {
  return {
    type: LAYOUTFILTER_POST,
    payload: {
      request: {
        url: "LayoutFilter",
        method: "POST",
        data: layoutFilter,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getByLayoutId(layoutFilter.layoutId));
          dispatch(getFilters());
        },
      },
    },
  };
}

export function editLayoutFilter(layoutFilter) {
  return {
    type: LAYOUTFILTER_PUT,
    payload: {
      request: {
        url: "LayoutFilter/",
        method: "PUT",
        data: layoutFilter,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getByLayoutId(layoutFilter.layoutId));
          dispatch(getFilters());
        },
      },
    },
  };
}
export function deleteLayoutFilter(layoutFilter) {
  return {
    type: LAYOUTFILTER_DELETE,
    payload: {
      request: {
        url: "LayoutFilter/",
        method: "DELETE",
        data: layoutFilter,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getByLayoutId(layoutFilter.layoutId));
          dispatch(getFilters());
        },
      },
    },
  };
}

export function clearFilterValueTable() {
  return {
    type: CLEAN_LAYOUTSFILTER,
  };
}
